import React from 'react';
import PropTypes from 'prop-types';
import ListWithDetails from 'components/Common/ListWithDetails';
import DocumentDetails from 'components/HealthRecords/Documents/DocumentDetails';
import DocumentBadge from 'components/HealthRecords/Documents/DocumentBadge';
import useFetchPatients from 'hooks/useFetchPatients';

const DocumentListWithDetails = (props) => {
  useFetchPatients(props.documents);
  return (
    <ListWithDetails
      patient={props.patient}
      items={props.documents}
      title={props.title}
      renderBadge={(item) => <Badge item={item} renderBadge={props.renderBadge} />}
      listColumnName="List"
      detailColumnName="Document"
      noDetail={props.noDetail}
      onClick={props.onClick}
      renderDetails={(item) => (
        <Details
          item={item}
          renderDetails={props.renderDetails}
          patient={props.patient}
          disableEdit={props.disableEdit}
          allowDelete={props.allowDelete}
          allowExpand={props.allowExpand}
          autoLoad={props.autoLoad}
          disablePatientBadge={props.disablePatientBadge}
          allowPin={props.allowPin}
        />
      )}
    />
  );
};

const Badge = ({ item, renderBadge }) =>
  renderBadge ? renderBadge(item) : <DocumentBadge item={item} />;

const Details = ({
  item,
  renderDetails,
  patient,
  disableEdit,
  allowDelete,
  allowExpand,
  autoLoad,
  disablePatientBadge,
  allowPin,
}) =>
  renderDetails ? (
    renderDetails(item)
  ) : (
    <DocumentDetails
      key={item.id}
      patient={patient}
      document={item}
      disableEdit={disableEdit}
      allowExpand={allowExpand}
      allowDelete={allowDelete}
      autoLoad={autoLoad}
      disablePatientBadge={disablePatientBadge}
      allowPin={allowPin}
    />
  );

DocumentListWithDetails.propTypes = {
  patient: PropTypes.object,
  documents: PropTypes.array.isRequired,
  title: PropTypes.string,
  renderBadge: PropTypes.func,
  renderDetails: PropTypes.func,
  allowDelete: PropTypes.bool,
  disableEdit: PropTypes.bool,
  allowExpand: PropTypes.bool,
  disablePatientBadge: PropTypes.bool,
  allowPin: PropTypes.bool,
};

DocumentListWithDetails.defaultProps = {
  disableEdit: true,
  allowExpand: false,
};

export default DocumentListWithDetails;
